// packages/shared/src/schemas/customer.ts
import { z } from 'zod'

export const CustomerPhoneSchema = z
  .string()
  .regex(/^[6-9]\d{9}$/, 'Enter a valid 10-digit Indian mobile number')

export const CustomerSchema = z.object({
  id: z.string(),
  phone: CustomerPhoneSchema,
  name: z.string(),
  email: z.string().email().nullable(),
  addressLine1: z.string().nullable(),
  addressLine2: z.string().nullable(),
  city: z.string().nullable(),
  state: z.string().nullable(),
  pincode: z.string().nullable(),
  landmark: z.string().nullable(),
  totalOrders: z.number().int().min(0),
  totalSpent: z.number().min(0),
  lastOrderAt: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
})

export const CustomerListQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(200).default(50),
  search: z.string().trim().optional(),
})

export type Customer = z.infer<typeof CustomerSchema>
export type CustomerListQuery = z.infer<typeof CustomerListQuerySchema>
